import type { Commodity } from '@enmon/commons/lib/shared';
import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import {
  DEFAULT_PAGINATION,
  type DefaultPagination,
  type FilterWithPaginationStateShape,
} from 'hooks/useFilterWithPagination';
import type { ManufacturersApiFilter } from 'lib/services';

export type ManufacturersFilter = {
  search?: ManufacturersApiFilter['search'];
  commodity?: Commodity;
  sort?: ManufacturersApiFilter['sort'];
};

export type ManufacturersFilterWithPaginationShape = FilterWithPaginationStateShape<ManufacturersFilter>;

const STATE_KEY = 'ManufacturersListFilterState';

export const DEFAULT_FILTER: ManufacturersFilter = {
  search: undefined,
  commodity: undefined,
  sort: {
    name: 'asc',
  },
};

export const DEFAULT_MANUFACTURERS_PAGINATION: DefaultPagination = {
  ...DEFAULT_PAGINATION,
};

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: DEFAULT_MANUFACTURERS_PAGINATION,
});

export const useManufacturersListFilterWithPagination = (): ManufacturersFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
